import { render } from "./CPOUserCreation.vue?vue&type=template&id=52148df3"
import script from "./CPOUserCreation.vue?vue&type=script&lang=js"
export * from "./CPOUserCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__